import { useState } from 'react';

import { SWReactIcons } from '@similarweb/icons';

import { Dropdown } from '../../../../components/Dropdown';
import { StyledDropdownOption } from '../../../../components/Dropdown/styles';
import { SAM_AVAILABLE_LANGUAGES } from '../../../../domain/insight';
import { SAM_LANGUAGE_CODE } from '../../../../domain/user';
import { useUserSettings } from '../../../../features/user/useUserSettings';
import { appStore } from '../../../../services/appStore';
import { translate } from '../../../../services/i18n';
import { PreferencesInnerModal } from '../PreferencesInnerModal';

import { StyledLanguageContainer, StyledLanguageTitle, StyledLanguageActionButton } from './styles';

type LanguagePreferencesProps = {
  isOpen: boolean;
  isNew?: boolean;
  onClose: () => void;
  onCloseInnerModal: () => void;
};

export const LanguagePreferences = ({ isOpen, onClose, onCloseInnerModal, isNew }: LanguagePreferencesProps) => {
  const { getUserSAMLanguageCode, setUserSettings } = useUserSettings();
  const initialLanguage = getUserSAMLanguageCode();

  const [isDropdownOpened, setIsDropdownOpened] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState<string>(initialLanguage);

  const handleSetSuccessfulToast = () => appStore.setShowToastAfterSuccessfulGeneration(true);

  const handleSave = () => {
    setUserSettings({ [SAM_LANGUAGE_CODE]: selectedLanguage }, { onSuccess: handleSetSuccessfulToast });
    appStore.resetEmailGeneration();
    onClose();
  };

  const handleSelecteLanguage = (id: string) => {
    setSelectedLanguage(id);
    setIsDropdownOpened(false);
  };

  return (
    <PreferencesInnerModal
      isOpen={isOpen}
      onClose={onClose}
      onReturn={onCloseInnerModal}
      onSave={handleSave}
      title={translate('insights.preferences.language.title')}
      subtitle={translate('insights.preferences.language.subtitle')}
      tooltipContent={translate('insights.preferences.countries.no_change.tooltip')}
      isSaveDisabled={selectedLanguage === initialLanguage}
      isNew={isNew}
    >
      <StyledLanguageContainer>
        <StyledLanguageTitle>{translate('insights.preferences.language.title')}</StyledLanguageTitle>
        <StyledLanguageActionButton onClick={() => setIsDropdownOpened(!isDropdownOpened)} isActive={isDropdownOpened}>
          {SAM_AVAILABLE_LANGUAGES.find(({ id }) => id === selectedLanguage)?.text}
          <SWReactIcons iconName={isDropdownOpened ? 'chev-up' : 'chev-down'} size="xs" />
        </StyledLanguageActionButton>
        <Dropdown
          minWidth="100%"
          isOpened={isDropdownOpened}
          onClose={() => setIsDropdownOpened(false)}
          maxHeight={308}
        >
          {SAM_AVAILABLE_LANGUAGES.map(({ text, id }) => (
            <StyledDropdownOption
              key={id}
              onClick={() => handleSelecteLanguage(id)}
              isSelected={id === selectedLanguage}
            >
              {text}
            </StyledDropdownOption>
          ))}
        </Dropdown>
      </StyledLanguageContainer>
    </PreferencesInnerModal>
  );
};
